import { Component, Input } from '@angular/core';
import { GROUP_COLUMNS, USERS_COLUMNS } from './permissions-table-helper';
import { PermissionLevel, PropertySet, PropertySetPermission } from '@miq/domain/property-sets';
import { of } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';

import { PermissionTableHelperService } from './permission-table-helper.service';

@UntilDestroy()
@Component({
  selector: 'miq-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss'],
  standalone: false,
})
export class PermissionsComponent {
  public haveAcessToPropertySet = false;
  public propertySetId: number;

  @Input()
  set propertySet(ps: PropertySet) {
    this.haveAcessToPropertySet = ps.level === PermissionLevel.Owner;
    this.propertySetId = ps.id;
    // when creating a new property set, permissions would fail
    this.permissionTableHelperService.permissions$ =
      ps?.id !== -1 ? this.permissionTableHelperService.loadPermissions(ps.id) : of({ group: [], user: [] });
  }

  public readonly groupColumns = GROUP_COLUMNS.map(c => ({ ...c }));
  public readonly userscolumns = USERS_COLUMNS.map(c => ({ ...c }));

  constructor(public permissionTableHelperService: PermissionTableHelperService) {}

  deletePermission(selectedPermission: Record<string, any>[]) {
    this.permissionTableHelperService.deletePermission(selectedPermission, this.propertySetId);
  }

  savePermission(payload: PropertySetPermission[]) {
    this.permissionTableHelperService.savePermission(payload, this.propertySetId);
  }

  updatePermission(payload: PropertySetPermission[]) {
    this.permissionTableHelperService.updatePermission(payload, this.propertySetId);
  }
}
